import React, { Component } from "react"
import { action, observable, observer } from "mobx-react"
import { NavLink } from "react-router-dom"
import { Menu, Dropdown } from "semantic-ui-react"
import app from "app.controller"
import shop from "shop/shop"
import config from "config"
import "./Menu.scss"
import languageStore from "../../stores/languageStore"

@observer
export default class MenuBySlug extends Component {
  
  state = {
    menu: false,
    current: false,
  }
  
  componentDidMount() {
    app.language.changed.add( this.load )
    this.load()
  }
  
  load = () => {
    const { currentLanguage } = languageStore
    let { slug } = this.props
    // shop.fetchFromWordPress( `acf/v3/menu?fields[name]=${slug}&lang=${app._currentLanguage}` )
    fetch( `${config.CMS_BASE}/wp-json/acf/v3/menu?slug[]=${slug}&lang=${currentLanguage}` )
      .then( res => res.json() )
      .then( res => res[ 0 ] )
      .then( ( layout ) => {
        this.setState( { menu: layout.acf.entries } )
      } )
      .catch( err => {
        console.warn( `Menu "${slug}" not available.` )
      } )
  }
  
  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }
  
  show = entry => {
    this.setState( { current: entry } )
  }
  
  hide = entry => {
    this.setState( { current: false } )
  }
  
  render() {
    const { children, slug, ...rest } = this.props
    const { menu } = this.state
    return (
      <Menu secondary>
        {menu && menu.map( entry => {
          let { link, group } = entry
          let isExternal = `${link.url}`.includes( "http" )
          if ( !link.url ) return null
          if ( group ) return <Dropdown key={link.title} text={link.title} pointing className="link item  ttu">
            <Dropdown.Menu>
              {/*<Dropdown.Header>Categories</Dropdown.Header>*/}
              {group.map( ( { link } ) => {
                if ( link.url ) return <Dropdown.Item key={link.url} target={link.target} as={NavLink} exact to={link.url}>{link.title}</Dropdown.Item>
                return null
              } )}
            </Dropdown.Menu>
          </Dropdown>
          if(isExternal)  return <Menu.Item key={link.url} target={link.target} as={"a"} exact href={link.url}>{link.title}</Menu.Item>
          return <Menu.Item key={link.url} target={link.target} as={NavLink} exact to={link.url}>{link.title}</Menu.Item>
        } )}
        {children}
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/MenuBySlug.js